import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import ItemCardEstimate from '@/components/GridItemCard/Card/components/ItemCardEstimate/ItemCardEstimate';
import { ItemSummary } from '@/types/item/ItemSummary';

export const EstimateComponentExperiment = createInfo<ItemSummary>({
    useText: ({ isLocked, isTimedPlusAuction, itemId }) => {
        if (isLocked || isTimedPlusAuction) {
            return null;
        }

        return (
            <div className="px-xs smMin:px-sm">
                <ItemCardEstimate
                    className={cn('text-xs smMin:text-sm')}
                    itemId={itemId}
                />
            </div>
        );
    },
});
